import { config } from '../../config/config';
import { Observable } from 'rxjs';
import { utilService } from '../utils';

function getTeacherDayTimetable(data) {
  return Observable.create((observer) => {
    fetch(config.api_url + config.url.teacher_day_timetable + data.params, {
      method: 'GET',
      headers: {
        Authorization: data.token,
      },
    })
      .then(utilService.handleResponse)
      .then((result) => {
        observer.next(result);
        observer.complete();
      })
      .catch((error) => {
        if (error.status === 401) {
          window.location.reload();
        }
      });
  });
}

export const teacherDayTimetableService = {
  getTeacherDayTimetable,
};
